import { ContentState, EditorState, AtomicBlockUtils, convertToRaw } from 'draft-js';

export default function convertSimpleCommentToContentState(comment) {
  const contentState = ContentState.createFromText(comment.content || '');
  let editorState = EditorState.createWithContent(contentState);

  if (comment.image) {
    const props = {
      src: comment.image,
      isLoading: false,
    };

    const entityKey = editorState
      .getCurrentContent()
      .createEntity('IMAGE', 'IMMUTABLE', props)
      .getLastCreatedEntityKey();
    editorState = EditorState.moveSelectionToEnd(editorState);
    editorState = AtomicBlockUtils.insertAtomicBlock(editorState, entityKey, ' ');
  }

  return {
    ownerId: comment.ownerId,
    content: convertToRaw(editorState.getCurrentContent()),
  };
}



// WEBPACK FOOTER //
// ./app/services/convert-simple-comment-to-content-state.js